<template>
  <div class="data-table-container">
    <div class="check-row" :style="border?'margin-bottom: 5px':''">
      <div class="left-op">
        <el-button
          v-for="(op,i) of filterOperations(tableOperations, undefined)"
          :key="i"
          :type="op.type?op.type:'text'"
          size="default"
          class="table-button"
          plain
          @click="op.action()"
        ><font-awesome-icon v-if="op.icon" :icon="op.icon" style="margin-right: 5px;" /><span v-if="op.name">{{ op.name }}</span></el-button>
        <!--   通用搜索     -->
        <el-input
          v-if="search == true"
          v-model="thisSearchValue.search"
          class="search-input"
          size="default"
          placeholder="请输入搜索内容"
          :prefix-icon="SearchIcon"
          @change="handleSearch"
        />
        <div v-else-if="search && search.constructor == Array && showSearch" style="white-space: nowrap; flex: 1; margin-right: 10px;">
          <div 
          v-for="(field,i) of search" 
            :key="i" 
            :title="field.lable" 
            class="search-item" 
            :style="{
              float: field.float ? field.float : 'none',
              marginLeft: field.margin?field.margin + 'px' : undefined
            }"
          >
            <!--   通用搜索     -->
            <el-input
              v-if="field.type == 'input'"
              size="default"
              :style="{width: field.width+'px'}"
              :placeholder="field.lable"
              :prefix-icon="SearchIcon"
              v-model="thisSearchValue[field.id]"
              @change="handleSearch"
            />
            <!--   下拉选择框     -->
            <el-select
              v-else-if="field.type == 'select'"
              class="select"
              :placeholder="field.lable"
              filterable
              clearable
              size="default"
              :style="{width: field.width+'px'}"
              :filter-method="(val) => { filterSelect(val, field) }"
              @change="selectChange(field)"
              v-model="thisRequestData[field.id]"
            >
              <el-option
                v-for="(op,i) of field.options"
                v-show="op.show != false && optionReload"
                :key="i"
                :label="op.name"
                :value="op.value"
              >
                <span style="float: left">{{ op.name }}</span>
                <span v-if="op.title" style="float: right; color: #8492a6; font-size: 14px">{{ op.title }}</span>
              </el-option>
            </el-select>
            <!--   日期     -->
            <el-date-picker
              v-if="field.type == 'date'"
              type="daterange"
              size="default"
              :style="{width: field.width ? field.width : 200 +'px'}"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="thisRequestData[field.id]"
              @change="handleSearch"
            />
            <!--   日期     -->
            <el-date-picker
              v-if="field.type == 'date-picker'"
              type="date"
              size="default"
              :style="{width: field.width ? field.width : 200 +'px'}"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="thisRequestData[field.id]"
              @change="handleSearch"
            />
          </div>
          <div v-if="statistics" class="search-item statistics" :style="{float: 'right'}">
            <div v-for="(item, index) in statistics" :key="index" class="text">{{ item }}</div>
          </div>
        </div>
      </div>
      <div class="tool-btns">
        <el-button-group>
          <!-- <el-button type="primary" size="default" title="编辑数据"><font-awesome-icon icon="edit" /></el-button> -->
          <el-button type="primary" size="default" title="重新加载" @click="initList"><font-awesome-icon icon="refresh" /></el-button>
          <el-button type="primary" size="default" title="导出为Excel" @click="exportExcel"><font-awesome-icon icon="file-download" /></el-button>
          <el-popover
            placement="bottom-end"
            trigger="click"
            width="100">
            <div class="checkbox-container">
              <el-checkbox class="checkbox" v-for="(f,i) of thisFields" :key="i" :label="f.name" v-model="f.show"/>
            </div>
            <template #reference>
              <el-button slot="reference" size="default" type="primary" title="隐藏显示字段"><font-awesome-icon icon="gear" /></el-button>
            </template>
          </el-popover>
        </el-button-group>
      </div>
    </div>
    <div class="table">
      <el-table
        v-if="!customer"
        :data="table.data"
        v-loading="table.loading"
        :border="border"
        :stripe="stripe"
        :height="height"
        class="data-table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column v-if="selection" type="selection" width="55">
        </el-table-column>
        <el-table-column
          v-for="(field,i) of showPropList"
          :key="i"
          :fixed="field.fixed"
          :prop="field.id"
          :label="field.name"
          :width="field.width?field.width:'auto'"
        >
          <template #default="scope">
            <el-image
              v-if="field.type == 'images'"
              :src="field.filter ? field.filter(scope.row)[0] : scope.row[field.id][0]"
              :preview-src-list="field.filter ? field.filter(scope.row) : scope.row[field.id]"
            />
            <el-image
              v-else-if="field.type == 'image'"
              :src="field.filter ? field.filter(scope.row) : scope.row[field.id]"
              :preview-src-list="field.filter ? [field.filter(scope.row)] : [scope.row[field.id]]"
            />
            <div v-else-if="field.type == 'tags'">
              <el-tag
                v-for="(t,i) of field.filter ? field.filter(scope.row) : field.format ? tagsFilter(scope.row[field.id], field.format) : scope.row[field.id]"
                :key="i"
                style="margin: 2px 4px 2px 0;"
                :type="t.type"
              >
                {{ t.text }}
              </el-tag>
            </div>
            <div v-else-if="field.type == 'link'">
              <div class="link" @click="field.action ? field.action(scope.row) : ''" title="点击跳转">
                <template v-if="field.filter ? field.filter(scope.row) : scope.row[field.id]">
                  <font-awesome-icon v-if="field.icon" icon="link" style="margin-right: 1px; width: 15px; height: 15px;" />
                </template>
                <span v-else>-</span>
                {{ field.filter ? field.filter(scope.row) : scope.row[field.id] }}
              </div>
            </div>
            <div v-else-if="field.type == 'date'">
              <div>{{ scope.row[field.id] }}</div>
            </div>
            <div v-else-if="field.type == 'index'">
              <div>{{ scope.$index + 1 + (table.current - 1) * page }}</div>
            </div>
            <div v-else>
              <div
                v-if="field.filter"
                v-html="field.filter(scope.row)"
              ></div>
              <div v-else :style="field.style">{{ scope.row[field.id] }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="operations.length > 0"
          :fixed="opfix?'right':false"
          :width="operationsWidth"
          label="操作"
        >
          <template #default="scope">
            <el-button-group v-if="opgroup">
              <el-button
                v-for="(op,i) of filterOperations(operations, scope.row)"
                :key="i"
                :type="op.type?op.type:'text'"
                size="default"
                plain
                @click="op.action(scope.row)"
                ><font-awesome-icon v-if="op.icon" :icon="op.icon" :style="{marginRight: op.name ? '5px' : ''}" /><span v-if="op.name">{{ op.name }}</span></el-button>
            </el-button-group>
            <div v-else>
              <el-button
                v-for="(op,i) of filterOperations(operations, scope.row)"
                :key="i"
                :type="op.type?op.type:'text'"
                size="default"
                plain
                @click="op.action(scope.row)"
                ><font-awesome-icon v-if="op.icon" :icon="op.icon" :style="{marginRight: op.name ? '5px' : ''}" /><span v-if="op.name">{{ op.name }}</span></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-else class="data-container">
        <slot :data="table.data" />
      </div>
    </div>
    <el-pagination
      v-if="page > 0"
      :current-page="table.current"
      :page-size="size"
      :page-sizes="[5, 10, 20, 50, 100, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="table.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
/* eslint-disable */
import config from '../config'
import request from '../core/request'
import {export_json_to_excel} from '../utils/Export2Excel'
import { Search as SearchIcon } from '@element-plus/icons-vue'

export default {
  name: 'DataTable',
  props: {
    url: {
      type: String,
      default: ''
    },
    requestData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    customer: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    selection: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: false
    },
    operationsWidth: {
      type: Number,
      default: 300
    },
    page: {
      type: Number,
      default: 0
    },
    height: {
      type: [ Number, String ],
      default: 400
    },
    statistics: {
      type: [ Array, Boolean ],
      default: undefined
    },
    search: {
      type: [ Array, Boolean ],
      default: undefined
    },
    edit: {
      type: Function,
      default: undefined
    },
    opgroup: {
      type: Boolean,
      default: false
    },
    opfix: {
      type: Boolean,
      default: true
    },
    fields: {
      type: Array,
      default: () => {
        return []
      }
    },
    operations: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableOperations: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataFilter: {
      type: Function,
      default: undefined
    },
    beforeRequest: {
      type: Function,
      default: undefined
    },
    requestMethod: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      SearchIcon: undefined,
      size: 10,
      thisFields: [],
      thisDataFilter: undefined,
      thisRequestData: {},
      thisSearchValue: {},
      showSearch: false,
      optionReload: true,
      table: {
        loading: true,
        data: [],
        total: 0,
        current: 1,
      },
      selects: []
    }
  },
  computed: {
    showPropList() {
      const arr = []
      for (const r of this.thisFields) {
        if (r.show != false) {
          arr.push(r)
        }
      }
      return arr;
    }
  },
  watch: {
    'fields': {
      handler(newVal) {
        this.thisFields = newVal
        let sign = location.href
        for (let r of this.thisFields) {
          sign += r.id
        }
        this.id = this.$md5(sign)
        if (this.$caches[this.id]) {
          for (let i = 0; i < this.thisFields.length; i++) {
            this.thisFields[i].show = this.$caches[this.id].charAt(i) === '1'
          }
        }
      },
      immediate: true
    },
    requestData: {
      handler(newVal) {
        this.thisRequestData = JSON.parse(JSON.stringify(newVal))
        if (this.search == true) {
          this.thisSearchValue.search = this.thisRequestData['search']
        }
        if (this.search && this.search.constructor == Array) {
          for(const s of this.search) {
            if (!this.thisRequestData[s.id]) {
              this.thisRequestData[s.id] = undefined
            }
            if (s.type == 'input') {
              this.thisSearchValue[s.id] = this.thisRequestData[s.id]
            }
          }
        }
      },
      immediate: true
    },
  },
  created() {
    this.SearchIcon = SearchIcon;
    if (!this.$caches) {
      this.$caches = {}
    }
    let sign = location.href
    this.thisFields = this.fields
    for (let r of this.thisFields) {
      sign += r.id
    }
    this.id = this.$md5(sign)
    let state = this.$caches[this.id] ? this.$caches[this.id] : ''
    this.thisDataFilter = this.dataFilter
    if (state) {
      for (let i = 0; i < this.thisFields.length; i++) {
        this.thisFields[i].show = state.charAt(i) === '1'
      }
    }
    if (this.requestData) {
      this.thisRequestData = JSON.parse(JSON.stringify(this.requestData))
    }
    if (this.search == true) {
      this.thisSearchValue.search = undefined
    }
    if (this.search && this.search.constructor == Array) {
      for(const s of this.search) {
        if (!this.thisRequestData[s.id]) {
          this.thisRequestData[s.id] = undefined
        }
        if (s.type == 'input') {
          this.thisSearchValue[s.id] = undefined
        }
      }
      this.$nextTick(() => {
        this.showSearch = true
      })
    }
    this.size = this.page
    if (!this.async) {
      this.initList()
    }
  },
  methods: {
    filterOperations(data, row) {
      const result = []
      for (const d of data) {
        if (d.show) {
          if (d.show(row)) {
            result.push(d)
          }
        } else {
          result.push(d)
        }
      }
      return result
    },
    initList() {
      this.table.loading = true
      if (this.page) {
        if (!this.thisRequestData) {
          this.thisRequestData = {}
        }
        this.thisRequestData.from = (this.table.current - 1) * this.size
        this.thisRequestData.limit = this.size
      }
      if (this.search) {
        if (!this.thisRequestData) {
          this.thisRequestData = {}
        }
        for (const k in this.thisSearchValue) {
          this.thisRequestData[k] = this.thisSearchValue[k] ? '%' + this.thisSearchValue[k] + '%' : '%%'
        }
      }
      for (const k in this.thisRequestData) {
        if (this.thisRequestData[k] === '' || this.thisRequestData[k] === ' ') {
          this.thisRequestData[k] = undefined
        }
      }
      const requestData = this.beforeRequest ? this.beforeRequest(JSON.parse(JSON.stringify(this.thisRequestData))) : this.thisRequestData
      const requestFunc = this.requestMethod ? this.requestMethod : request
      requestFunc({
        url: config.BASE_URL + this.url,
        method: 'post',
        data: requestData
      }).then(resp => {
        if (this.thisDataFilter) {
          const filterData = this.thisDataFilter(resp)
          if (filterData) {
            if (!this.page) {
              this.table.data = filterData.data
            } else {
              this.table.data = filterData.data.data
              this.table.total = filterData.data.total
            }
          }
        } else {
          if (resp.code === -1) {
            this.$message.error(resp.message)
          } else {
            if (!this.page) {
              this.table.data = resp.data
            } else {
              this.table.data = resp.data.data
              this.table.total = resp.data.total
            }
          }
        }
        setTimeout(() => {
          this.table.loading = false
        }, 0)
      }).catch(e => {
        console.log(e)
        this.$message.error('获取数据失败：' + e)
      })
    },
    tagsFilter (val, format) {
      if (format[val]) {
        return [
          {
            type: format[val][0],
            text: format[val][1]
          }
        ]
      } else {
        return [
          {
            type: 'danger',
            text: '错误：未定义的' + val
          }
        ]
      }
    },
    selectChange(field) {
      var prevent
      if (field.change) {
        prevent = field.change(field.id, this.thisRequestData)
      }
      if (prevent !== false) {
        this.handleSearch()
      }
    },
    filterSelect(val, field) {
      for (const item of field.options) {
        item.show = item.title ? (item.name + item.title).includes(val) : item.name.includes(val)
      }
      this.optionReload = false
      this.$nextTick(() => {
        this.optionReload = true
      })
    },
    handleSizeChange(v) {
      this.size = v
      this.initList()
    },
    handleCurrentChange(v) {
      this.table.current = v
      this.initList()
    },
    handleSearch() {
      this.table.current = 1
      console.log(this.thisRequestData)
      this.initList()
    },
    exportExcel() {
      if (this.page) {
        if (!this.thisRequestData) {
          this.thisRequestData = {}
        }
        this.thisRequestData.from = (this.table.current - 1) * this.size
        this.thisRequestData.limit = this.size
      }
      if (this.search) {
        if (!this.thisRequestData) {
          this.thisRequestData = {}
        }
        for (const k in this.thisSearchValue) {
          this.thisRequestData.search = this.thisSearchValue[k] ? '%' + this.thisSearchValue[k] + '%' : '%%'
        }
      }
      const requestData = this.beforeRequest ? this.beforeRequest(JSON.parse(JSON.stringify(this.thisRequestData))) : this.thisRequestData
      requestData.from = 0
      requestData.limit = this.table.total
      request({
        url: config.BASE_URL + this.url,
        method: 'post',
        data: requestData
      }).then(resp => {
        const data = this.page ? resp.data.data : resp.data
        const tHeader = []
        const filterVal = []
        for (const f of this.thisFields) {
          tHeader.push(f.name)
          filterVal.push(f)
        }
        const finalData = data.map((v,i) => filterVal.map(j => {
          if (j.type == 'index') {
            return i
          } else if (j.type == 'tags') {
            const arr = j.filter ? j.filter(v) : j.format ? this.tagsFilter(v[j.id], j.format) : v[j.id]
            let res = ''
            for (const t of arr) {
              res += t.text + ', '
            }
            return res.length > 0 ? res.substring(0, res.length - 2) : res
          } else if (j.filter) {
            return JSON.stringify(j.filter(v))
          } else {
            return v[j.id]
          }
        }))
        export_json_to_excel({
          header: tHeader,
          data: finalData,
          filename: 'Excel数据'
        })
      })
    },
    handleSelectionChange(rows) {
      this.selects = rows
    },
    getSelection() {
      return new Promise((resolve, reject) => {
        const isSelectAll = this.selects.length == this.table.data.length
        if (!isSelectAll) {
          resolve({
            isSelectAll: isSelectAll,
            data: this.selects
          })
        } else {
          if (this.search) {
            if (!this.thisRequestData) {
              this.thisRequestData = {}
            }
            for (const k in this.thisSearchValue) {
              this.thisRequestData.search = this.thisSearchValue[k] ? '%' + this.thisSearchValue[k] + '%' : '%%'
            }
          }
          const requestData = this.beforeRequest ? this.beforeRequest(JSON.parse(JSON.stringify(this.thisRequestData))) : this.thisRequestData
          requestData.from = 0
          requestData.limit = this.table.total
          request({
            url: config.BASE_URL + this.url,
            method: 'post',
            data: requestData
          }).then(resp => {
            const data = this.page ? resp.data.data : resp.data
            resolve({
              isSelectAll: isSelectAll,
              data: data
            })
          }).catch(e => {
            reject(e)
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.data-table-container {
  padding: 20px;
  background-color: #ffffff;
}

.check-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 5px 20px;

  .left-op {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    flex: 1;

    .search-input {
      width: 200px;
      margin-left: 10px;
    }
    .search-item {
      display: inline-block;
      .select {
        width: 84px;
      }
    }
    .statistics {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      border: 1px solid #FB7B508f;
      border-radius: 5px;
      .text {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        height: 26px;
        min-width: 20px;
        font-size: 14px;
        color: #606266;
        &+.text {
          border-left: 1px solid #FB7B508f;
        }
      }
    }
  }

  .tool-btns {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
}

.data-table {
  margin-bottom: 15px;
}
.data-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
}

.link {
  color: #409EFF;
  cursor: pointer;
  transition: color 0.2s;
  max-width: 99%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover {
    color: #66b1ff;
  }
  &:active {
    color: #337ecc;
  }
}

.table {
  background-color: #ffffff;
}

.checkbox-container {
  display: flex;
  flex-direction: column;

  .checkbox {
    width: 100px;
    margin-bottom: 10px;
    margin-right: 0;
  }
}
</style>
